var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 148,
    viewBox: "0 0 352 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 148,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6805 -852C-6805 -853.105 -6804.1 -854 -6803 -854H24234C24235.1 -854 24236 -853.105 24236 -852V4936C24236 4937.1 24235.1 4938 24234 4938H-6803C-6804.1 4938 -6805 4937.1 -6805 4936V-852Z",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1149,
    transform: "translate(-544 -454)",
    fill: "#F4F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -472,
    y: -280,
    width: 1296,
    height: 783,
    rx: 8,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.667 0C344.801 0 351.396 6.59447 351.396 14.7292C351.396 22.8639 344.801 29.4583 336.667 29.4583H252.5C260.635 29.4583 267.229 36.0528 267.229 44.1875C267.229 52.3222 260.635 58.9167 252.5 58.9167H298.792C306.926 58.9167 313.521 65.5111 313.521 73.6458C313.521 81.7805 306.926 88.375 298.792 88.375H277.384C267.127 88.375 258.812 94.9695 258.812 103.104C258.812 108.527 263.021 113.437 271.438 117.833C279.572 117.833 286.167 124.428 286.167 132.562C286.167 140.697 279.572 147.292 271.438 147.292H96.7917C88.657 147.292 82.0625 140.697 82.0625 132.562C82.0625 124.428 88.657 117.833 96.7917 117.833H14.7292C6.59447 117.833 0 111.239 0 103.104C0 94.9695 6.59447 88.375 14.7292 88.375H98.8958C107.031 88.375 113.625 81.7805 113.625 73.6458C113.625 65.5111 107.031 58.9167 98.8958 58.9167H46.2917C38.157 58.9167 31.5625 52.3222 31.5625 44.1875C31.5625 36.0528 38.157 29.4583 46.2917 29.4583H130.458C122.324 29.4583 115.729 22.8639 115.729 14.7292C115.729 6.59447 122.324 0 130.458 0H336.667ZM336.667 58.9167C344.801 58.9167 351.396 65.5111 351.396 73.6458C351.396 81.7805 344.801 88.375 336.667 88.375C328.532 88.375 321.938 81.7805 321.938 73.6458C321.938 65.5111 328.532 58.9167 336.667 58.9167Z",
    fill: "#F4F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M177.732 9.21029C179.68 6.01548 184.32 6.01548 186.268 9.2103L248.326 110.939C250.359 114.271 247.961 118.543 244.058 118.543H119.942C116.039 118.543 113.641 114.271 115.674 110.939L177.732 9.21029Z",
    fill: "white",
    stroke: "#ACB2DA",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M167.335 34.1382C168.596 32.0202 171.825 33.6146 170.91 35.9037L149.502 89.4762C147.21 95.2125 150.615 101.634 156.649 102.956L194.941 111.339C197.28 111.851 196.907 115.293 194.514 115.293H122.519C120.967 115.293 120.007 113.603 120.801 112.27L167.335 34.1382Z",
    fill: "#F8F8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178 42.7215C178 38.6187 179.791 35.293 182 35.293C184.209 35.293 186 38.6187 186 42.7215V79.8644C186 83.9672 184.209 86.793 182 86.793C179.791 86.793 178 83.9672 178 79.8644V42.7215Z",
    fill: "#A6AEDF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178 95.293C178 93.0837 179.761 91.293 181.933 91.293H182.067C184.239 91.293 186 93.0837 186 95.293C186 97.502 184.239 99.293 182.067 99.293H181.933C179.761 99.293 178 97.502 178 95.293Z",
    fill: "#A6AEDF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213 61.2914C219.602 72.0066 219.602 72.0066 230 89.2914",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.999 102.292C240.495 106.12 240.495 106.12 244.429 112.292",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.596 92.4071C232.556 93.849 232.556 93.849 234.072 96.1793",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M244.808 113.146C235.652 113.233 235.652 113.233 220.981 113.215",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M170.768 30.3842C174.275 24.1772 174.275 24.1772 180 14.2914",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M164 41.2942C164.996 39.7518 164.996 39.7518 166.622 37.2942",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M129.759 99.0076C130.697 97.5516 130.697 97.5516 132.227 95.2309",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-6803 -853H24234V-855H-6803V-853ZM24235 -852V4936H24237V-852H24235ZM24234 4937H-6803V4939H24234V4937ZM-6804 4936V-852H-6806V4936H-6804ZM-6803 4937C-6803.55 4937 -6804 4936.55 -6804 4936H-6806C-6806 4937.66 -6804.66 4939 -6803 4939V4937ZM24235 4936C24235 4936.55 24234.6 4937 24234 4937V4939C24235.7 4939 24237 4937.66 24237 4936H24235ZM24234 -853C24234.6 -853 24235 -852.552 24235 -852H24237C24237 -853.657 24235.7 -855 24234 -855V-853ZM-6803 -855C-6804.66 -855 -6806 -853.657 -6806 -852H-6804C-6804 -852.552 -6803.55 -853 -6803 -853V-855Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.50c3aa49dae9c19de19df6da51c0888b.svg";
export { ForwardRef as ReactComponent };